var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100%" } },
    [
      _c(
        "w-card-title",
        { style: { padding: "10px 15px", alignItems: "center" } },
        [
          _vm._v(" " + _vm._s(_vm.$ct("activity")) + " "),
          _c("w-spacer"),
          _c(
            "w-menu",
            {
              staticClass: "ml",
              attrs: { right: "" },
              model: {
                value: _vm.filterMenuOpen,
                callback: function ($$v) {
                  _vm.filterMenuOpen = $$v
                },
                expression: "filterMenuOpen",
              },
            },
            [
              _c(
                "w-button",
                {
                  style: { fontSize: "13px" },
                  attrs: { slot: "activator" },
                  slot: "activator",
                },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "filter" } }),
                  _vm._v(" " + _vm._s(_vm.$ct("filter")) + " "),
                ],
                1
              ),
              _c("w-transition-slide-height", [
                _vm.filterMenuOpen
                  ? _c(
                      "div",
                      { staticClass: "w-dropdown-select-items filter-content" },
                      [
                        _c("div", { staticClass: "filter-actions" }, [
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.selectAllFilters()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("common.select-all")))]
                          ),
                          _c("span", { staticClass: "separator" }, [
                            _vm._v("|"),
                          ]),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.deselectAllFilters()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$ct("common.deselect-all")))]
                          ),
                        ]),
                        _vm._l(_vm.filterList, function (item) {
                          return _c(
                            "div",
                            { key: item.value, staticClass: "filter-item" },
                            [
                              _c("w-checkbox", {
                                attrs: {
                                  label: item.text,
                                  value: _vm.isFilterSelected(item.value),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.toggleFilter(item.value, $event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "filter-close" },
                          [
                            _c(
                              "w-button",
                              {
                                attrs: { block: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.filterMenuOpen = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$ct("common.close")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _c(
            "w-dropdown",
            {
              staticClass: "ml",
              style: { fontSize: "13px" },
              attrs: { items: _vm.actionList },
              on: {
                click: function ($event) {
                  return _vm.triggerAction($event)
                },
              },
            },
            [
              _c("w-fa", { staticClass: "mrs", attrs: { icon: "plus" } }),
              _vm._v(" " + _vm._s(_vm.$ct("add-activity")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        {
          style: { paddingTop: "0" },
          attrs: { tag: "w-card-content", grow: "" },
        },
        [
          _vm.filteredHistory.length <= 0
            ? _c("div", { style: { paddingTop: "15px" } }, [
                _vm._v(_vm._s(_vm.$ct("no-activity"))),
              ])
            : _vm._e(),
          _vm._l(_vm.filteredHistory, function (event) {
            return _c("app-crm-history-event", {
              key: event.ID,
              attrs: { event: event, state: _vm.state },
              on: {
                edit: function ($event) {
                  return _vm.edit($event)
                },
              },
            })
          }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editHistoryEvent,
            callback: function ($$v) {
              _vm.editHistoryEvent = $$v
            },
            expression: "editHistoryEvent",
          },
        },
        [
          _c("app-crm-edit-history-event", {
            attrs: {
              contact: _vm.contact,
              crm: _vm.crm,
              event: _vm.historyEvent,
            },
            on: {
              cancel: function ($event) {
                return _vm.cancel()
              },
              save: function ($event) {
                return _vm.saveHistory($event)
              },
              update: function ($event) {
                return _vm.updateHistory($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }